import PickUpMethodOption from 'components/Checkout/Sections/PickUpMethodOption/PickUpMethodOption';
import { withPickUpMethodOptionProps } from 'viewModel/checkout/sections/pickUpMethodOption/withPickUpMethodOptionProps';

export default withPickUpMethodOptionProps(PickUpMethodOption);
